import type { PlaycastWebrtcQualityRawStats } from '@playcastdotio/CoreTypes';
import type { GuestStatsSample } from './guestStreamStatsSampler';

/**
 * A clientStats sample for a WebCodecs canvas viewer.
 *
 * Video is not on any RTP peer connection, so the tick must not invent decode fps, loss,
 * or a standing queue from the suspended primary. Omitted wire fields stay omitted.
 */
const UNSAMPLED_RAW: PlaycastWebrtcQualityRawStats = {
  hasActiveVideoTrack: false,
  currentRoundTripTime: 0,
  averageDecodeTimePerFrame: 0,
  jitter: 0,
  jitterBufferDelay: 0,
  packetLossPercentage: 0,
  packetSamples: [],
  recentFreezeDelta: 0,
  freezeBaseline: 0,
  recentFreezes: [],
  avgInterFrameDelay: 0,
  nackBaseline: 0,
  recentNackDelta: 0,
  recentNacks: [],
  bitsPerSecond: 0,
  videoKbps: 0,
  avgFrameRate: 0,
  maxRecentFrameRate: 0,
  minRecentFrameRate: 0,
  isFrameRateAboveMinimum: false,
  isFrameRateStable: false,
  isFrameRatePanic: false,
  isBitratePanic: false,
  isMobile: false,
};

export function unsampledWebCodecsSample(nowMs: number): GuestStatsSample {
  return {
    raw: UNSAMPLED_RAW,
    congestion: { standingQueueMs: null },
    wire: { sampledAtEpochMs: nowMs },
    framesDecoded: 0,
    freezeSignalAvailable: false,
  };
}
